import * as $ from 'jquery'; //Importar jQuery

window.jQuery = window.$ = $; //Inicializar jQuery
